function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useClassPrepend } from "../../../../hook/ui/common/className/useClassPrepend";
import "./unstyledTableBody.css";

/*
    Returns a list of rows for a table

    props
        (array, required)  columns    See description in TableHeader
        (array, required)  rows       List of objects, where each object has keys corresponding to column dataKeys
                                        - The value in each row object is the cell data to render (can be altered by renderCell function in column)
                                        - example = [ 
                                            { 
                                                name: "Guide Book", 
                                                count: 42 
                                            },
                                            { 
                                                name: "Pencil", 
                                                count: 1
                                            } 
                                        ]
        (string, required) minWidth   The minimum width of each row
*/

const UnstyledTableBody = ({
  classPrepend = "unstyled",
  columns,
  rows,
  minWidth,
  onRowClick = null,
  // props to exclude from ...rest that are passed from wrapper components
  noDataMessage,
  enablePagination,
  expandedRowRender = null,
  ...rest
}) => {
  const [getClassName, getClassNameWithGlobal] = useClassPrepend(classPrepend);
  return /*#__PURE__*/React.createElement("div", _extends({}, getClassNameWithGlobal("table-body"), rest), rows.map((row, rIndex) => {
    return /*#__PURE__*/React.createElement("div", {
      key: rIndex
    }, /*#__PURE__*/React.createElement("div", _extends({}, getClassNameWithGlobal(`table-row${onRowClick ? " table-row-selectable" : ""}${expandedRowRender?.isExpanded ? " expanded" : ""}`), {
      onClick: onRowClick ? () => onRowClick(row) : () => null,
      style: {
        minWidth: minWidth
      }
    }), columns.map((column, cIndex) => {
      const cellData = row[column.dataKey];
      let cellAlignClassname = "";
      if (column?.alignContent === "right") {
        cellAlignClassname = "table-row-cell-right-align";
      }
      if (column?.alignContent === "center") {
        cellAlignClassname = "table-row-cell-center-align";
      }
      return /*#__PURE__*/React.createElement("div", _extends({
        key: cIndex
      }, getClassNameWithGlobal(`table-row-cell ${cellAlignClassname}`), {
        style: column.columnStyles || null
      }), typeof cellData !== "undefined" ? column.renderCell ? column.renderCell(cellData, row) : cellData : null);
    })), expandedRowRender?.isExpanded ? /*#__PURE__*/React.createElement("div", getClassNameWithGlobal(expandedRowRender?.isExpanded ? 'table-row-expanded-content' : ''), expandedRowRender?.view(row)) : null);
  }));
};
export { UnstyledTableBody };